// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__S9av0","content":"styles_content__3i2_8","checkbox":"styles_checkbox__27XkQ","checkboxLabel":"styles_checkboxLabel__cul00"};